import React from 'react';
import PropTypes from 'prop-types';

const TransitionChild = ({ children }) => React.Children.toArray(children)[0] || null;

TransitionChild.propTypes = {
  children: PropTypes.node,
};

export default TransitionChild;
